import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '@shared/shared.module';

import { SparkBusinessNumberComponent } from './business-number/business-number.component';
import { SparkCompanyNumberComponent } from './company-number/company-number.component';
import { SparkCountryModule } from '../country/country.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [SparkBusinessNumberComponent, SparkCompanyNumberComponent],
  imports: [CommonModule, SharedModule, SparkCountryModule, ReactiveFormsModule],
  exports: [SparkBusinessNumberComponent, SparkCompanyNumberComponent]
})
export class SparkBusinessModule {}
